import { Flex, spacing, StyleProps, useIsMobileView } from 'deepstash-ui';
import useSource from 'providers/hooks/useSource';
import React from 'react';
import SectionTitle from 'src/components/layout/components/SectionTitle';
import SubsectionHeader from 'src/components/metacontent/components/SubsectionHeader';
import SourceCollapsedLarge from 'src/components/source/source-collapsed/SourceCollapsedLarge';
import SourceCollapsedMedium from 'src/components/source/source-collapsed/SourceCollapsedMedium';
import { SourceType } from 'types/enums';
import { GAP_SIZE_REM, SECTION_GAP_REM } from 'utils/global';
import { normalizeSource } from 'utils/normalizers/source';
import commonStrings from 'utils/strings/commonStrings';

const SimilarSourcesList: React.FC<StyleProps> = ({ ...props }) => {
  const isMobileView = useIsMobileView();

  const { source, similarSources, relatedPosts } = useSource();

  if (!similarSources?.length && !relatedPosts?.similar_articles?.length)
    return null;

  const sectionTitle =
    source && source.sourceType === SourceType.BOOK
      ? commonStrings.metacontent.similarBooksSectionHeader
      : commonStrings.metacontent.similarSourcesSectionHeader;

  return (
    <Flex flexDir="column" w="100%" {...props}>
      {isMobileView ? (
        <SubsectionHeader
          pt={{ base: GAP_SIZE_REM, md: SECTION_GAP_REM }}
          pb={GAP_SIZE_REM}
        >
          {sectionTitle}
        </SubsectionHeader>
      ) : (
        <SectionTitle
          pt={SECTION_GAP_REM}
          pb={spacing.toRem(48)}
          title={sectionTitle}
        />
      )}

      <Flex
        flexDir={{ base: 'column', md: 'row' }}
        w="100%"
        position="relative"
        gridGap={GAP_SIZE_REM}
        pb={GAP_SIZE_REM}
      >
        {!!relatedPosts?.similar_articles?.length &&
          relatedPosts?.similar_articles.map((post, index) => {
            return isMobileView ? (
              <SourceCollapsedLarge
                key={`source-card-${index}`}
                source={normalizeSource(post)}
                headingSize="h4"
              />
            ) : (
              <SourceCollapsedMedium
                headingSize="h4"
                key={`source-card-${index}`}
                source={normalizeSource(post)}
              />
            );
          })}
        {!relatedPosts?.similar_articles?.length &&
          !!similarSources?.length &&
          similarSources.map((source, index) => {
            return isMobileView ? (
              <SourceCollapsedLarge
                key={`source-card-${index}`}
                source={source}
                headingSize="h4"
              />
            ) : (
              <SourceCollapsedMedium
                headingSize="h4"
                key={`source-card-${index}`}
                source={source}
              />
            );
          })}
      </Flex>
    </Flex>
  );
};

export default SimilarSourcesList;
